// extracted by mini-css-extract-plugin
export default {"overlayMessageContainer":"OverlayMessage__overlayMessageContainer","slide-in":"OverlayMessage__slide-in"};